import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'antd';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faDotCircle } from '@fortawesome/free-solid-svg-icons';

const { Meta } = Card;

class Tracking extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            track_order_3: '',
        };
    }

    componentDidMount() {
        const { steps } = this.props;
        const { track_order_3 } = steps;

        this.setState({ track_order_3 });
    }

    render() {
        const { track_order_3 } = this.state;
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = mm + '/' + dd + '/' + yyyy;
        return (
            <div style={{ width: '100%' }}>
                <h3>Order Tracking Summary</h3>
                <table>
                    <tbody>
                        <tr>
                            <td style={{padding:"0 15px 0 15px"}}>Tracking Code</td>
                            <td>{track_order_3.value}</td>
                        </tr>
                        <tr>
                            <td style={{padding:"0 15px 0 15px"}}>Est. Delivery Date</td>
                            <td>{today}</td>
                        </tr>
                        <tr>
                            <td style={{padding:"0 15px 0 15px"}}>Status</td>
                            <td>On Delivery</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

Tracking.propTypes = {
    steps: PropTypes.object,
};

Tracking.defaultProps = {
    steps: undefined,
};

export const Conversation = [
    {
        id: "welcome_1",
        message: "Hello, awesome people!",
        trigger: "welcome_2"
    },
    {
        id: "welcome_2",
        message: "Welcome to Wood'n Decor!",
        trigger: "welcome_3"
    },
    {
        id: "welcome_3",
        message: "It seems that you are looking for a Wood'n Decor-ation for your wall",
        trigger: "welcome_4"
    },
    {
        id: "welcome_4",
        options: [
            {
                value: "search", label: "Search Product", trigger: "search_product_1"
            },
            {
                value: "track", label: "Track My Order", trigger: "track_order_1"
            }
        ]
    },



    // Search Product
    {
        id: "search_product_1",
        message: "Okay, let's begin!",
        trigger: "search_product_2"
    },
    {
        id: "search_product_2",
        message: "I will ask you several questions, then I will provide the matched products based on your preferences",
        trigger: "search_product_3"
    },
    {
        id: "search_product_3",
        message: "Which decoration shape do you want?",
        trigger: "search_product_4"
    },
    {
        id: "search_product_4",
        options: [
            {
                value: "rectangle", label: "Rectangle", trigger: "search_product_5"
            },
            {
                value: "circle", label: "Circle", trigger: "search_product_5"
            },
            {
                value: "any", label: "Any shape will do", trigger: "search_product_5"
            },
        ]
    },
    {
        id: "search_product_5",
        message: "Nice choice!",
        trigger: "search_product_6"
    },
    {
        id: "search_product_6",
        message: "What color do you want?",
        trigger: "search_product_7"
    },
    {
        id: "search_product_7",
        options: [
            {
                value: "brown", label: "Brown", trigger: "search_product_8"
            },
            {
                value: "red", label: "Red", trigger: "search_product_8"
            },
            {
                value: "any", label: "Any color will do", trigger: "search_product_8"
            }
        ]
    },
    {
        id: "search_product_8",
        message: "I would choose the same color, too!",
        trigger: "search_product_10"
    },
    {
        id: "search_product_10",
        message: "Last question",
        trigger: "search_product_11"
    },
    {
        id: "search_product_11",
        message: "Do you want any lighting on it?",
        trigger: "search_product_12"
    },
    {
        id: "search_product_12",
        options: [
            {
                value: "yes", label: "Yes", trigger: "search_product_13"
            },
            {
                value: "no", label: "No", trigger: "search_product_13"
            }
        ]
    },
    {
        id: "search_product_13",
        message: "That's a good choice!",
        trigger: "search_product_15"
    },
    {
        id: "search_product_15",
        message: "Okay, we're all set now",
        trigger: "search_product_15"
    },
    {
        id: "search_product_15",
        message: "Here are your results",
        trigger: "search_product_16"
    },
    {
        id: "search_product_16",
        component: (
            <Carousel
                centered
                slidesPerPage={1}
                arrowLeft={<FontAwesomeIcon icon={faAngleDoubleLeft} />}
                arrowLeftDisabled={<FontAwesomeIcon icon={faDotCircle} />}
                arrowRight={<FontAwesomeIcon icon={faAngleDoubleRight} />}
                arrowRightDisabled={<FontAwesomeIcon icon={faDotCircle} />}
                addArrowClickHandler
            >

                <a href="https://www.etsy.com/listing/233959151/wooden-arrow-wall-decoration-wall-art" target="_blank"  rel="noopener noreferrer" style={{
                    textDecoration: "none"
                }}>
                    <Card
                        hoverable
                        style={{ width: "240px" }}
                        cover={<img alt="example" src="https://i.etsystatic.com/5827725/r/il/d3deb6/774415428/il_794xN.774415428_8dfw.jpg" />}
                    >
                        <Meta title="Wooden Arrow Wall Decoration" description="USD 3.81" />
                    </Card>
                </a>

                <a href="https://www.etsy.com/listing/781818824/scrabble-tiles-wooden-letters-wall" target="_blank"  rel="noopener noreferrer" style={{
                    textDecoration: "none"
                }}>
                    <Card
                        hoverable
                        style={{ width: "240px" }}
                        cover={<img alt="example" src="https://i.etsystatic.com/20848761/r/il/fe6c15/2264481330/il_794xN.2264481330_sgpj.jpg" />}
                    >
                        <Meta title="Scrabble tiles | Wooden letters" description="USD 1.73" />
                    </Card>
                </a>

                <a href="https://www.etsy.com/listing/772844307/wooden-set-of-hearts-6mm-thick-art" target="_blank"  rel="noopener noreferrer" style={{
                    textDecoration: "none"
                }}>
                    <Card
                        hoverable
                        style={{ width: "240px" }}
                        cover={<img alt="example" src="https://i.etsystatic.com/17416477/r/il/f32732/2210904349/il_794xN.2210904349_dftj.jpg" />}
                    >
                        <Meta title="Wooden Set of Hearts - 6mm Thick" description="USD 10.30" />
                    </Card>
                </a>

                <a href="https://www.etsy.com/listing/672478195/wooden-wall-door-name-sign-6mm-thick" target="_blank"  rel="noopener noreferrer" style={{
                    textDecoration: "none"
                }}>
                    <Card
                        hoverable
                        style={{ width: "240px" }}
                        cover={<img alt="example" src="https://i.etsystatic.com/17416477/r/il/011f04/1784245227/il_794xN.1784245227_sy5d.jpg" />}
                    >
                        <Meta title="Wooden Wall Door Name Sign" description="USD 6.29" />
                    </Card>
                </a>

            </Carousel>
        ),
        end: true
    },



    // Order Tracking
    {
        id: "track_order_1",
        message: "Sure, I'll help you to track your order",
        trigger: "track_order_2"
    },
    {
        id: "track_order_2",
        message: "Please enter your tracking order (it should be number-only)",
        trigger: "track_order_3"
    },
    {
        id: "track_order_3",
        user: true,
        validator: (value) => {
            if (isNaN(value)) {
                return "Tracking order must be a number-only"
            } else {
                if (value.length > 5) {
                    return "Max. 5 characters"
                }
                return true;
            }
        },
        trigger: "track_order_4"
    },
    {
        id: "track_order_4",
        message: "Thank you for using our service, this is your order tracking summary",
        trigger: "track_order_5"
    },
    {
        id: "track_order_5",
        component: (
            <Tracking />
        ),
        end: true
    }
]